// API configuration for standalone AEO app
export const getApiBaseUrl = (): string => {
  // Check for environment variable first
  if (typeof process !== 'undefined' && process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // Check for window config (set in index.html) - ignore empty strings
  if (typeof window !== 'undefined') {
    const windowUrl = (window as any).REACT_APP_API_BASE_URL;
    if (windowUrl && windowUrl.trim && windowUrl.trim() !== '') {
      return windowUrl;
    }
  }
  
  // Default: use localhost in development, or Cloud Function URL in production
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:3001';
    }
    
    // Check if we're in staging environment
    if (hostname.includes('staging') || hostname.startsWith('staging-dot')) {
      return 'https://aeo-api-staging-ei7aeedd4a-uc.a.run.app';
    }
  }
  
  // Production API (Cloud Run — same target as scripts/deploy_with_tests.sh `gcloud run deploy aeo-api`)
  return 'https://aeo-api-1028353131390.us-central1.run.app';
};

export const API_BASE_URL = getApiBaseUrl();


